type ExitHook = () => Promise<void> | void

const hooks = new Set<ExitHook>()

/**
 * Register teardown to run before the app navigates away to the platform (logout,
 * leaving impersonation). Returns an unregister function.
 *
 * A module-level registry rather than a React context because one caller
 * (`leaveImpersonation`) is a plain function outside the tree.
 */
export function registerExitHook(hook: ExitHook): () => void {
  hooks.add(hook)
  return () => {
    hooks.delete(hook)
  }
}

/**
 * Run every registered hook. Never rejects, and resolves after `timeoutMs` even if a
 * hook hangs — an exit the user asked for must not be blocked by cleanup.
 */
export async function runExitHooks(timeoutMs = 1500): Promise<void> {
  if (hooks.size === 0) return
  const all = Promise.allSettled([...hooks].map(async (hook) => hook()))
  await Promise.race([all, new Promise<void>((resolve) => window.setTimeout(resolve, timeoutMs))])
}
